import axios from "axios";
import { db } from "@src/services/db";
import ChatSession from "@src/types/ChatSession";
import {lastSyncHelper} from "@src/helpers/lastSyncHelper";

class BotMessageService {

    async getBotMessagesOld(sessionId: number, oldestId: number | null) {
        try {
            let url = `operator/v4/bot/messages/${sessionId}`;
            if (oldestId) url += `/${oldestId}`;

            const response = await axios.get(url, { withCredentials: true });
            return response.data;
        } catch (e) {
            console.error(e);
            return null;
        }
    }

    async updateSessionLastMessage(sessionId: number, lastMessage: any) {
        try {
            await db.sessions.update(sessionId, {
                last_message: lastMessage,
                updated_at: new Date().toISOString(),
            } as any);
        } catch {}
    }
}

export default new BotMessageService();